import * as Yup from "yup";

import { Typography } from "@material-ui/core";

import React, { useEffect } from "react";

import { TAXIS_LOGIN } from "../../constants";

const ExternalSignIn = () => {
  useEffect(() => {
    window.location.href = TAXIS_LOGIN;
  }, []);

  return <Typography>Redirecting...</Typography>;
};

export default ExternalSignIn;
